module.exports = __webpack_public_path__ + "static/media/gallery8.3d5afddd.jpg";